import React, { useEffect } from 'react'
import { useField } from 'formik'
import { countries } from '@sketch/constants'
import { Form, Select, SelectOption } from '@sketch/components'

const countryList = Object.entries(countries)
interface CountryFieldProps {
  name: string
  disabled?: boolean
  fetchBrowserLang?: boolean
}

const CountryField: React.FC<CountryFieldProps> = ({
  name,
  disabled,
  fetchBrowserLang,
}) => {
  const [field, meta, { setValue }] = useField({ name })

  // try to assert which country the user is in based on their browser language
  useEffect(() => {
    const getCountryCodeFromLanguage = () => {
      if (!fetchBrowserLang) {
        return
      }

      const language = navigator.language
      const countryCode = language.split('-')[1] || 'US' // Default to 'US' if no country code is found
      setValue(countryCode.toUpperCase())
    }

    getCountryCodeFromLanguage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form.Field
      id="country"
      label="Country"
      errorText={meta.touched ? meta.error : undefined}
    >
      <Select {...field} onChange={setValue} disabled={disabled}>
        {countryList.map(([countryCode, country]) => (
          <SelectOption key={countryCode} value={countryCode}>
            {country}
          </SelectOption>
        ))}
      </Select>
    </Form.Field>
  )
}

export default CountryField
